import { render, staticRenderFns } from "./SaleEditHightlightEdit.vue?vue&type=template&id=a2fef156&scoped=true"
import script from "./SaleEditHightlightEdit.vue?vue&type=script&lang=ts"
export * from "./SaleEditHightlightEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fef156",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2fef156')) {
      api.createRecord('a2fef156', component.options)
    } else {
      api.reload('a2fef156', component.options)
    }
    module.hot.accept("./SaleEditHightlightEdit.vue?vue&type=template&id=a2fef156&scoped=true", function () {
      api.rerender('a2fef156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/SaleEditHightlightEdit.vue"
export default component.exports